import { FactionJsonldFactionRead } from '@/api/generated';
import { CheckFactionOptions } from '@/atoms/forms/CheckFactionChip';

export const formatFactionOptions = (factions: FactionJsonldFactionRead[]): CheckFactionOptions =>
  factions
    .sort((a, b) => (a.name && b.name ? a.name.localeCompare(b.name) : 0))
    .reduce((acc, faction) => {
      return {
        ...acc,
        [faction.reference]: {
          ...faction,
          acf: {
            // eslint-disable-next-line camelcase
            display_title: faction.name,
            color: faction.color,
            reference: faction.reference,
          },
        },
      };
    }, {});
